import { Controller } from '@hotwired/stimulus'
import { dispatchCustomEvent } from '../../../helpers/custom_events_helper'
import * as liveRegion from '../../../helpers/live_region_helper'
import { updateUrlParams } from '../../../helpers/url_helper'

const SIDE_BAR_OPEN_CLASS = 'components--ui--side-bar--open'
export default class extends Controller {
  connect() {
    this.handleKeydown = this.handleKeydown.bind(this)
    document.addEventListener('keydown', this.handleKeydown)

    this.currentTab = null
  }

  disconnect() {
    document.removeEventListener('keydown', this.handleKeydown)
  }

  isOpen() {
    return this.element.classList.contains(SIDE_BAR_OPEN_CLASS)
  }

  isClosed() {
    return !this.isOpen()
  }

  handleKeydown(event) {
    if (event.key === 'Escape' && this.isOpen()) {
      this.close()
    }
  }

  open() {
    this.element.classList.add(SIDE_BAR_OPEN_CLASS)
    this.element.setAttribute('aria-hidden', 'false')
    updateUrlParams({ sidebar: 'open' })

    liveRegion.polite.setContent('Sidebar opened')
    dispatchCustomEvent(window, 'galette:sidebar:open')
  }

  close() {
    this.element.classList.remove(SIDE_BAR_OPEN_CLASS)
    this.element.setAttribute('aria-hidden', 'true')
    updateUrlParams({ sidebar: null })

    liveRegion.polite.setContent('Sidebar closed')

    dispatchCustomEvent(window, 'galette:sidebar:close')
  }
}
